export default {
  common: {
    brand: "USFans Spreadsheet",
    nav: {
      home: "Inicio",
      shoppingGuide: "Guía de compras",
      spreadsheet: "Hoja de cálculo",
      categories: "Categorías",
      resources: "Recursos",
      faq: "FAQ",
    },
    cta: {
      explore: "Explorar la hoja",
      buyNow: "Comprar ahora",
      visitMain: "Visitar el sitio principal",
      readGuide: "Leer la guía completa",
    },
    categoriesTitle: "Comprar por categoría",
    categoriesSubtitle: "Explora todas las categorías de productos en la tienda principal",
    browseCategories: "Explorar categorías",
    jumpCategory: "Ir a una categoría",
    footer: {
      tagline: "Un centro de recursos independiente sobre la hoja de cálculo de USFans: guías, reseñas y consejos prácticos.",
      disclaimer: "Este es un sitio web informativo independiente, no afiliado a USFans ni a la tienda principal. Los enlaces externos se abren en una pestaña nueva.",
      resourcesTitle: "Recursos",
      categoriesTitle: "Categorías",
      legalTitle: "Legal",
      rights: "Todos los derechos reservados.",
    },
    backHome: "Volver al inicio",
    published: "Publicado",
    updated: "Última actualización",
    readMore: "Leer el artículo",
    languageLabel: "Idioma",
  },
};